window.addEventListener('DOMContentLoaded', () => {
    const instagramClass = '.b-instagram__container';
    const instagramContainer = document.querySelector(instagramClass);
    if (instagramContainer) {
        const instagramCount = instagramContainer && instagramContainer.querySelectorAll('.b-instagram__inner .swiper-slide').length;

        if (window.innerWidth >= 768) {
            instagramCount < 2 ? instagramContainer.classList.add('no-swiper') : instagramContainer.classList.remove('no-swiper');
        }

        var instagramSwiper = new Swiper(instagramContainer, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            watchOverflow: true,
            loop: false,
            pagination: {
                el: '.swiper-pagination-instagram',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-instagram',
                prevEl: '.swiper-button-prev-instagram',
            }, 

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 20,
                }
            }
        })
    }
});
